export const processStatus = {
  unset: 0,
  success: 1,
  failure: 2,
}
